module.exports = __webpack_public_path__ + "img/mode-1.872c5cd7.png";